import React from 'react';
import { InstantSearch, Configure } from 'react-instantsearch';

import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import GridWithSidebar from 'components/consumer/GridWithSidebar';
import { PhotoCardsResultSearch } from 'components/consumer/inspiration-photos-grid/search-state/utils';
import useFilters from 'components/consumer/inspiration-photos-grid/hooks/useFilters';

const DEFAULT_TABS_CONFIG = {
  products: true,
  productsTitle: ' ',
  productsHideLoadMore: true,
};

const SearchCustomerPhotosContent = ({
  facetFilters,
  getCustomProps,
  hoveredValue,
  indexName,
  searchState,
  searchStateQuery,
  toggleReviewOnHover,
  updateSearchPage,
}) => {
  const { actions: filterActions } = useFilters();

  return (
    <div className="w-full">
      <InstantSearch
        searchClient={searchClient}
        /* TODO: CON-7887: (Codemod generated): `searchState` is no longer supported. This is now handled via an `onStateChange` callback.
        See https://www.algolia.com/doc/guides/building-search-ui/upgrade-guides/react-hooks/#replace-searchstate-with-initialuistate */
        searchState={searchState}
        indexName={indexName}
      >
        <Configure
          query={searchStateQuery}
          hitsPerPage={9}
          facetFilters={facetFilters}
          facets={['*']}
          numericFilters=""
        />

        <div className="[&_.infinite-scroll-component]:flex [&_.infinite-scroll-component]:flex-row [&_.infinite-scroll-component]:items-start [&_.infinite-scroll-component]:flex-wrap [&_.infinite-scroll-component]:justify-between [&_.infinite-scroll-component]:min-w-full">
          <GridWithSidebar
            getCustomProps={getCustomProps}
            gridItemType="customer-photo"
            mobileItemsPerRow={1}
            naturalHeightImages
            renderGrid={({
              selectedGridItem,
              updateSelectedGridItem,
              showOnTop = false,
            }) => (
              <PhotoCardsResultSearch
                filterActions={filterActions}
                hoveredValue={hoveredValue}
                onHoverHandler={toggleReviewOnHover}
                searchMore={updateSearchPage}
                selectedGridItem={selectedGridItem}
                showModalOnClick
                showOnTop={showOnTop}
                updateSelectedGridItem={updateSelectedGridItem}
              />
            )}
            tabsConfig={DEFAULT_TABS_CONFIG}
            variant="InspirationPage"
          />
        </div>
      </InstantSearch>
    </div>
  );
};

export default SearchCustomerPhotosContent;
